"use client";

import type React from "react";
import { Footer } from "@/components/web/footer";
import { TailwindIndicator } from "@/components/web/layout/tailwindIndicator";
import { Navbar } from "@/components/web/navigation/navbar";
import { TabProvider, useTab } from "@/lib/_context/websiteTab";
import { TradieRoleProvider } from "@/lib/_providers/TradieRoleProvider";
import "@/styles/website/globals.css";

function HomeContent({
  children,
  diyer,
  tradie,
  registry,
}: {
  children: React.ReactNode;
  diyer: React.ReactNode;
  tradie: React.ReactNode;
  registry: React.ReactNode;
}) {
  const { activeTab } = useTab();

  return (
    <div className="">
      <Navbar />

      <main className="flex-1">
        {children}
        <div className="flex flex-col gap-6">
          {activeTab === "diyer" && diyer}
          {activeTab === "tradie" && tradie}
          {activeTab === "registry" && registry}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function HomeLayoutClient({
  children,
  diyer,
  tradie,
  registry,
  isDiyer,
  isTradie,
}: {
  children: React.ReactNode;
  diyer: React.ReactNode;
  tradie: React.ReactNode;
  registry: React.ReactNode;
  isDiyer: boolean;
  isTradie: boolean;
}) {
  return (
    <TradieRoleProvider isDiyer={isDiyer} isTradie={isTradie}>
      <TabProvider>
        <HomeContent diyer={diyer} registry={registry} tradie={tradie}>
          {children}
        </HomeContent>
        <TailwindIndicator />
      </TabProvider>
    </TradieRoleProvider>
  );
}
